import { get } from 'lodash';

const root = state => get(state, 'PhysicalState.physicalList');

export const getPhysicalListData = state =>
  get(root(state), 'physicalListData', []);
export const getPhysicalListDataError = state =>
  get(root(state), 'physicalListDataError', null);
export const getLoading = state => get(root(state), 'loading', false);
export const getPrintLoading = state => get(root(state), 'printLoading', false);
export const getPrintError = state => get(root(state), 'printError', null);
export const getDeleteMsg = state => get(root(state), 'deleteMsg', null);
export const getDeleteErrorMsg = state =>
  get(root(state), 'deleteErrorMsg', null);
export const getPrintLoadingError = state =>
  get(root(state), 'printLoadingError', null);
export const getFromDateMax = state => get(root(state), 'fromDateMax', null);
export const getToDateMin = state => get(root(state), 'toDateMin', null);
export const getPrintData = state => get(root(state), 'printData', '');



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/physical/state/PhysicalList/selectors.js